import {FC} from 'react'
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalTitle,
    ModalXCloseButton
} from '@/components/ui/modal-atoms/ModalAtoms'
import {Button} from '@/components/ui/button/Button'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'

interface MailerResetConfirmationModalProps {
    onClose: () => void
    onConfirm: () => void
}

export const MailerResetConfirmationModal: FC<MailerResetConfirmationModalProps> = ({onClose, onConfirm}) => {
    const {t} = useTranslation()

    return (
        <>
            <ModalOverlay onClick={onClose} />
            <Modal width="440px">
                <ModalHeader>
                    <Flexbox justify="space-between" align="center" fullWidth>
                        <ModalTitle>{t('mailer:reset_confirm_title')}</ModalTitle>
                        <ModalXCloseButton onClick={onClose} />
                    </Flexbox>
                </ModalHeader>
                <ModalBody>
                    <Text size="textSm" palette="neutral" shade="700">
                        {t('mailer:reset_confirm_description')}
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" variant="ghost" onClick={onClose}>
                        <Text size="textMd">{t('commons:cancel')}</Text>
                    </Button>
                    <Button type="button" variant="primaryDanger" onClick={onConfirm}>
                        <Text size="textMd">{t('mailer:reset_confirm_action')}</Text>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
